import React from 'react';

import * as ArtistListCell from './ArtistListCell.jsx';
import { Block, JsonLD, withConfig, withGridConfig } from '../common/Block.jsx';
import { EmptyContentPlaceholder } from '../layout/Builder.jsx';
import { Column, Row, Spaced } from '../common/Container.jsx';
import Defaults from '../layout/Defaults.jsx';
import { default as Image, ImageSrcSet } from '../common/Image.jsx';
import Kit from '../layout/Kit.jsx';
import Layout from '../common/Layout.jsx';
import { ContentContainer as _ContentContainer, withPaging } from '../common/List.jsx';
import { Footer, View as LoadingView } from '../common/Loading.jsx';
import Name from '../common/Name.jsx';
import ScreenSize from '../common/ScreenSize.jsx';
import { withSlideshowConfiguration, withSlideshowInitialization } from '../common/Slideshow.jsx';
import { LayoutTabs, LayoutTabSelectionDropDown, withLayoutTabOptions } from '../common/Tab.jsx';
import Url from '../common/Url.jsx';

const ArtistHelper = {
    images: function (artist, blockConfig) {
        const values = {};
        if (!artist || !blockConfig) {
            return values;
        }
        switch (blockConfig.thumbnailImage) {
            case 0:
                // Cover
                values.thumbnail = artist.cover;
                if (blockConfig.thumbnailAlternate) {
                    values.alternate = artist.profile;
                }
                break;
            case 1:
                // Profile
                values.thumbnail = artist.profile;
                if (blockConfig.thumbnailAlternate) {
                    values.alternate = artist.cover;
                }
                break;
        }
        return values;
    }
};

const defaultColumnCount = 5;

class _ArtistsListComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};

        this.handleRequestData = this.handleRequestData.bind(this);
        this.handleResponseDataPostProcess = this.handleResponseDataPostProcess.bind(this);
    }

    componentDidMount() {
        this.setState({
            id: this.props.blockIdentifier
        });
        this.props.onRegisterRequestDataHandler(this.handleRequestData);
        this.props.onRegisterResponseDataPostProcessHandler(this.handleResponseDataPostProcess);

        if (!this.props.data) {
            this.props.onLoad();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.screenSize != this.state.screenSize) {
            this.setState({
                screenSize: this.props.screenSize
            });
        }
        if (!this.props.builder || !this.props.blockConfig || !prevProps.context) {
            return;
        }
        const prevBlockConfig = this.props.onNormalizeBlockConfig(prevProps);
        const blockConfig = this.props.onNormalizeBlockConfig(this.props);
        if (prevBlockConfig.order != blockConfig.order ||
            prevProps.context.maxLimit != blockConfig.maxLimit ||
            prevProps.context.order != blockConfig.order || // Extra check for new builder context
            prevProps.context.tag != blockConfig.tags) {
            this.props.onReset();
            this.props.onLoad();
        }
    }

    handleRequestData(requestData) {
        const blockConfig = this.props.onNormalizeBlockConfig(this.props);
        requestData.listId = this.props.context.listId;
        requestData.maxLimit = blockConfig.maxLimit;
        requestData.order = blockConfig.order;
        requestData.tags = this.props.context.tag;

        if (this.props.builder) {
            requestData.limit = (this.props.blockConfig && this.props.blockConfig.columns || defaultColumnCount) * 3;
            if (requestData.maxLimit < requestData.limit) {
                requestData.limit = requestData.maxLimit
            }
        }
    }

    handleResponseDataPostProcess(data) {
        const blockConfig = this.props.onNormalizeBlockConfig(this.props);
        if (blockConfig.maxLimit && data.artists && data.artists.length >= blockConfig.maxLimit) {
            data.hasMore = false;
        }
    }

    render() {
        const isEmpty = this.props.data && (!this.props.data.artists || this.props.data.artists.length == 0);
        if (!this.props.builder && isEmpty) {
            return null;
        }
        const style = { position: 'relative' };
        let styleTabs = {};
        let styleTabsContainer = {};
        if (this.props.blockConfig && this.props.blockConfig.layout) {
            Block.mapStyleConfigProps(style, this.props.blockConfig.layout, (propName, propValue, propUnit) => {
                switch (propName) {
                    case 'alignmentTabs':
                        return true;
                    case 'marginBottomTabs':
                    case 'marginLeftTabs':
                    case 'marginRightTabs':
                    case 'marginTopTabs':
                    case 'paddingBottomTabs':
                    case 'paddingLeftTabs':
                    case 'paddingRightTabs':
                    case 'paddingTopTabs':
                        if (!propValue || !propUnit) {
                            return true;
                        }
                        if (!styleTabs) {
                            styleTabs = {};
                        }
                        styleTabs[propName.replace('Tabs', '')] = `${propValue}${propUnit}`;
                        return true;
                    case 'maxWidthTabs':
                        if (propValue && propUnit) {
                            styleTabsContainer = { maxWidth: `${propValue}${propUnit}` };
                        }
                        return true;
                    case 'textAlignTabs':
                        if (!styleTabs) {
                            styleTabs = {};
                        }
                        if (propValue) {
                            styleTabs[propName.replace('Tabs', '')] = propValue;
                        }
                        return true;
                }
            });
            styleTabs = Kit.Page.updateComponentStyle(styleTabs, this.props.config, this.props.pageType);
            if (!styleTabsContainer.maxWidth) {
                styleTabsContainer = {
                    maxWidth: Kit.Page.maxWidth(this.props.config, this.props.pageType)
                };
            }
            styleTabsContainer = Block.updateAlignment(styleTabsContainer, this.props.blockConfig.layout.alignmentTabs);
        }
        if (isEmpty) {
            let blankState;
            if (this.props.onBlankState) {
                blankState = this.props.onBlankState(Name.Block.Artist.List);
            }
            if (blankState) {
                return blankState;
            }
            return (
                <React.Fragment>
                    {
                        !this.props.legacy &&
                        <LayoutTabSelectionDropDown
                            key="selector"
                            tab={this.props.tab}
                            tabs={this.props.tabs}
                            onBlockMove={this.props.onBlockMove}
                            onSelect={this.props.onTabClick} />
                    }
                    <ContentContainer>
                        <EmptyContentPlaceholder style={style}>You haven't added any artists yet. Once you do, you'll see them here.</EmptyContentPlaceholder>
                    </ContentContainer>
                </React.Fragment>
            );
        }
        let Content;
        switch (this.props.tab) {
            case Layout.Type.Result.List:
                Content = List;
                break;
            case Layout.Type.Result.Thumbnails:
                Content = Grid;
                break;
        }
        const contentProps = {
            active: this.props.active,
            blockConfig: this.props.blockConfig,
            blockIdentifier: this.props.blockIdentifier,
            builder: this.props.builder,
            config: this.props.config,
            frameDoc: this.props.frameDoc,
            hasMore: this.props.data && this.props.data.hasMore,
            imageSize: this.props.imageSize,
            legacy: this.props.legacy,
            loading: this.props.loading,
            listData: this.props.data && this.props.data.artists,
            pageType: this.props.pageType,
            queryDataSub: this.props.queryDataSub,
            queryLayout: this.props.queryLayout,
            querySub: this.props.querySub,
            screenSize: this.state.screenSize,
            onLoadMore: this.props.onLoadMore
        };
        let id;
        if (this.state.id) {
            id = `tabs__content-${this.state.id}`;
        }
        const tabIncludes = {}
        if (this.props.blockConfig) {
            if (this.props.blockConfig.hasListLayout || (this.props.blockConfig.list && this.props.blockConfig.list.enabled)) {
                tabIncludes[Layout.Type.Result.List] = true;
            }
            if (this.props.blockConfig.hasSlideshowLayout || (this.props.blockConfig.slideshow && this.props.blockConfig.slideshow.enabled)) {
                tabIncludes[Layout.Type.Result.Slideshow] = true;
            }
            if (this.props.blockConfig.hasThumbnailsLayout || (this.props.blockConfig.grid && this.props.blockConfig.grid.enabled)) {
                tabIncludes[Layout.Type.Result.Thumbnails] = true;
            }
        }
        return (
            <React.Fragment>
                {
                    this.props.builder &&
                    !this.props.legacy &&
                    <LayoutTabSelectionDropDown
                        key="selector"
                        tab={this.props.tab}
                        tabs={this.props.tabs}
                        onBlockMove={this.props.onBlockMove}
                        onSelect={this.props.onTabClick} />
                }
                {
                    this.props.data &&
                    (this.props.builder || this.props.tabs && this.props.tabs.length > 1) &&
                    <div style={styleTabsContainer}>
                        <LayoutTabs
                            builder={this.props.builder}
                            className="artists__controls"
                            includes={tabIncludes}
                            style={styleTabs}
                            tab={this.props.tab}
                            tabs={this.props.tabs}
                            onTabClick={this.props.onTabClick} />
                    </div>
                }
                <div id={id} className="tabs__content tabs__content--artists current" style={style}>
                    {
                        !this.props.data &&
                        <LoadingView />
                    }
                    {
                        this.props.data &&
                        <React.Fragment>
                            {
                                Content != undefined &&
                                <Content {...contentProps} />
                            }
                            {
                                tabIncludes[Layout.Type.Result.Slideshow] &&
                                <Slideshow {...contentProps} navEnabled={true} responsive={true} visible={this.props.tab == Layout.Type.Result.Slideshow} />
                            }
                        </React.Fragment>
                    }
                </div>
                <JsonLD
                    baseUrl={this.props.baseUrl}
                    builder={this.props.builder}
                    jsonLD={this.props.jsonLD}
                    path="artist"
                    querySub={this.props.querySub} />
            </React.Fragment>
        );
    }
}
const ArtistsListComponent =
    withConfig(
        withPaging(
            withGridConfig(
                withLayoutTabOptions(_ArtistsListComponent),
                defaultColumnCount
            ),
            { path: 'artists', resultKey: 'artists' }));

function ContentContainer(props) {
    return (
        <_ContentContainer className={props.className} style={props.style} type="artists">
            {props.children}
        </_ContentContainer>
    );
}

// #region GRID

function Grid(props) {
    let columnCount = (props.blockConfig.grid && props.blockConfig.grid.columns) || props.blockConfig.columns || defaultColumnCount;
    if (props.blockConfig.grid) {
        switch (props.screenSize) {
            case ScreenSize.Mobile:
                columnCount = props.blockConfig.grid.columnsPhone || 2;
                break;
            case ScreenSize.Tablet:
                columnCount = props.blockConfig.grid.columnsTablet || 3;
                break;
        }
    }
    const columnSize = Layout.columnSize(columnCount);
    const listData = props.listData || [];

    let CellComponent = GridCell;
    let animation, columnClassName, contentConfig, rowClassName;
    if (props.blockConfig.grid) {
        animation = props.blockConfig.grid.animation;
        CellComponent = ArtistListCell.ArtistCellContainer;
        columnClassName = 'col--custom';
        contentConfig = Defaults.cellDesign(props.config, props.blockConfig, Kit.Context.Cell.Artist.Grid);
        rowClassName = 'cont__row--custom';
    }
    let lineSpacing;
    const layoutStyles = Block.mapLayoutStyleConfigPropsWithPageKit({}, props, { alignment: 'textAlign', configKey: 'grid' }, (propName, propValue, propUnit) => {
        switch (propName) {
            case 'cell':
            case 'columns':
            case 'columnsPhone':
            case 'columnsTablet':
            case 'columnSpacing':
            case 'enabled':
                return true;
            case 'lineSpacing':
                if (propUnit) {
                    const value = propValue || 0;
                    lineSpacing = `${value}${propUnit}`;
                }
                return true;
        }
    });
    return (
        <React.Fragment>
            <ContentContainer className="cont--kit__wrapper" style={layoutStyles.containerStyle}>
                <Spaced className="cont--kit__content" style={layoutStyles.style}>
                    <Row className={rowClassName}>
                        {listData.map((d, i) => (
                            <Column
                                key={d.artistId}
                                className={columnClassName}
                                size={columnSize}
                                style={props.builder ? { pointerEvents: 'none' } : undefined}>
                                <CellComponent
                                    animation={animation}
                                    columnCount={columnCount}
                                    columnSpacing={props.blockConfig.grid && props.blockConfig.grid.columnSpacing}
                                    contentConfig={contentConfig}
                                    index={i}
                                    lineSpacing={lineSpacing}
                                    listData={listData}
                                    type="grid"
                                    {...props}
                                    data={d} />
                            </Column>
                        ))}
                    </Row>
                </Spaced>
            </ContentContainer>
            <Footer
                active={props.active}
                builder={props.builder}
                hasMore={props.hasMore}
                loading={props.loading}
                onLoadMore={props.onLoadMore} />
        </React.Fragment>
    );
}

function GridCell(props) {
    const images = ArtistHelper.images(props.data, props.blockConfig);
    const imageTuples = Image.sizes.map(function (d) {
        return { size: d, url: Image.url(images.thumbnail, d, d, 'c_fill') };
    });
    let alternate;
    if (images.alternate) {
        const altImageTuples = Image.sizes.map(function (d) {
            return { size: d, url: Image.url(images.alternate, d, d, 'c_fill') };
        });
        alternate = (
            <ImageSrcSet
                className="artist__card__img artist__card__img--overlay"
                builder={props.builder}
                config={props.config}
                data={{ alt: props.data.name, title: props.data.name }}
                imageTuples={altImageTuples} />
        );
    }
    const link = Url.getLink('', `artist/${props.data.artistId}`, { sub: props.querySub, layout: props.queryLayout, dataSub: props.queryDataSub }, props.builder);
    let linkStyle;
    if (props.builder) {
        linkStyle = { pointerEvents: 'none' };
    }
    return (
        <a href={link} className="artist__card" style={linkStyle}>
            <figure className="artist__card__img-wrapper">
                <ImageSrcSet
                    className="artist__card__img"
                    builder={props.builder}
                    config={props.config}
                    data={{ alt: props.data.name, title: props.data.name }}
                    imageTuples={imageTuples} />
                {alternate}
            </figure>
            <div className="artist__card__name notranslate">{props.data.name}</div>
        </a>
    );
}

// #endregion GRID

// #region LIST

class List extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};

        this.handleMouseEnter = this.handleMouseEnter.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
    }

    componentDidMount() {
        if (this.props.builder || (this.props.blockConfig.list && !this.props.blockConfig.list.previewOnHover)) {
            return;
        }
        window.addEventListener('resize', this.handleResize);
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        if (this.props.builder || (this.props.blockConfig.list && !this.props.blockConfig.list.previewOnHover)) {
            return;
        }
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }

    handleMouseEnter(data) {
        if (!data || this.props.builder || (this.props.blockConfig.list && !this.props.blockConfig.list.previewOnHover)) {
            return;
        }
        this.setState({
            activeArtist: data
        });
    }

    handleResize() {
        if (!this.props.active || !this.state.preview || !this.state.previewState || !this.state.preview.parentElement) {
            return;
        }
        switch (this.state.previewState) {
            case 'abs':
                this.state.preview.style.left = `${this.state.preview.parentElement.offsetWidth - this.state.preview.offsetWidth}px`;
                break;
            case 'fixed':
                if (!this.state.preview.parentElement.getClientRects) {
                    break;
                }
                const rects = this.state.preview.parentElement.getClientRects();
                if (rects.length) {
                    this.state.preview.style.left = `${rects[0].x + rects[0].width - this.state.preview.offsetWidth}px`;
                }
                break;
        }
    }

    handleScroll() {
        if (!this.props.active) {
            return;
        }
        let list = this.state.list;
        if (!list) {
            list = document.getElementById(`artist__list-${this.props.blockIdentifier}`);
            if (!list) {
                return;
            }
            this.setState({
                list
            });
        }
        let preview = this.state.preview;
        if (!preview) {
            preview = document.getElementById(`artist__preview-${this.props.blockIdentifier}`);
            if (!preview) {
                return;
            }
            this.setState({
                preview
            });
        }
        if (list.offsetHeight < preview.offsetHeight) {
            // List is shorter than preview height => No need to update preview position
            return;
        }
        let container = this.state.container;
        if (!container) {
            container = document.getElementById(`tabs__content-${this.props.blockIdentifier}`);
            if (!container) {
                return;
            }
            this.setState({
                container
            });
        }

        const containerOffset = container.offsetTop - 60;
        let previewState;
        if (window.scrollY > containerOffset) {
            previewState = 'fixed';
            if (window.scrollY > containerOffset + list.offsetHeight - preview.offsetHeight) {
                previewState = 'abs';
                if (preview.parentElement) {
                    preview.style.left = `${preview.parentElement.offsetWidth - preview.offsetWidth}px`;
                }
            } else if ((this.state.previewState == 'abs' || !preview.style.left) && preview.parentElement && preview.parentElement.getClientRects) {
                const rects = this.state.preview.parentElement.getClientRects();
                if (rects.length) {
                    preview.style.left = `${rects[0].x + rects[0].width - this.state.preview.offsetWidth}px`;
                }
            }
        } else {
            preview.style.left = '';
        }
        this.setState({
            previewState
        });
    }

    render() {
        const listData = this.props.listData || [];
        let columnCount = (this.props.blockConfig.list && this.props.blockConfig.list.columns) || 3;
        if (this.props.blockConfig.list) {
            switch (this.props.screenSize) {
                case ScreenSize.Mobile:
                    columnCount = this.props.blockConfig.list.columnsPhone || 2;
                    break;
                case ScreenSize.Tablet:
                    columnCount = this.props.blockConfig.list.columnsTablet || 3;
                    break;
            }
        }
        const columnSize = Layout.columnSize(columnCount);
        let containerStyle, content, lineSpacing, style;
        if (this.props.blockConfig.list) {
            const previewStyle = {};
            const layoutStyles = Block.mapLayoutStyleConfigPropsWithPageKit({}, this.props, { alignment: 'textAlign', configKey: 'list' }, (propName, propValue, propUnit) => {
                switch (propName) {
                    case 'cell':
                    case 'columns':
                    case 'columnsPhone':
                    case 'columnsTablet':
                    case 'columnSpacing':
                    case 'enabled':
                    case 'preview':
                        return true;
                    case 'lineSpacing':
                        if (propUnit) {
                            const value = propValue || 0;
                            lineSpacing = `${value}${propUnit}`;
                        }
                        return true;
                    case 'previewSize':
                        if (propValue && propUnit) {
                            previewStyle.width = `${propValue}${propUnit}`;
                        }
                        return true;
                }
            });
            containerStyle = layoutStyles.containerStyle;
            style = layoutStyles.style;

            let contentConfig;
            if (this.props.blockConfig.list.cell && this.props.blockConfig.list.cell.desktop && this.props.blockConfig.list.cell.desktop.blocks && this.props.blockConfig.list.cell.desktop.blocks.length > 0) {
                contentConfig = this.props.blockConfig.list.cell;
            } else {
                // Default cell design
                contentConfig = Defaults.Block[Name.Block.Artist.List].ListCell;
            }
            let listStyle, previewClassName, previewContentConfig;
            if (this.props.blockConfig.list.previewOnHover) {
                if (this.state.previewState) {
                    previewClassName = `artist__preview--${this.state.previewState}`;
                }
                if (!previewStyle.width) {
                    previewStyle.width = '50%';
                }
                if (this.props.blockConfig.list.preview && this.props.blockConfig.list.preview.desktop && this.props.blockConfig.list.preview.desktop.blocks && this.props.blockConfig.list.preview.desktop.blocks.length > 0) {
                    previewContentConfig = this.props.blockConfig.list.preview;
                } else {
                    previewContentConfig = Defaults.Block[Name.Block.Artist.List].ListPreviewCell;
                }
                let marginLeft, marginRight;
                if (previewContentConfig.desktop && previewContentConfig.desktop.page && previewContentConfig.desktop.page.config && previewContentConfig.desktop.page.config.layout) {
                    if (previewContentConfig.desktop.page.config.layout.marginLeft && previewContentConfig.desktop.page.config.layout.marginLeft.value && previewContentConfig.desktop.page.config.layout.marginLeft.value > 0 && previewContentConfig.desktop.page.config.layout.marginLeft.unit) {
                        marginLeft = `${previewContentConfig.desktop.page.config.layout.marginLeft.value}${previewContentConfig.desktop.page.config.layout.marginLeft.unit}`
                    }
                    if (previewContentConfig.desktop.page.config.layout.marginRight && previewContentConfig.desktop.page.config.layout.marginRight.value && previewContentConfig.desktop.page.config.layout.marginRight.value > 0 && previewContentConfig.desktop.page.config.layout.marginRight.unit) {
                        marginRight = `${previewContentConfig.desktop.page.config.layout.marginRight.value}${previewContentConfig.desktop.page.config.layout.marginRight.unit}`
                    }
                }
                listStyle = { width: `calc(100% - ${previewStyle.width} - ${marginLeft || '0px'} - ${marginRight || '0px'})` }
            } else {
                listStyle = { width: '100%' };
            }
            let activeArtist = this.state.activeArtist;
            if (!activeArtist && listData.length > 0) {
                activeArtist = listData[0]
            }
            if (this.props.builder) {
                switch (this.props.screenSize) {
                    case ScreenSize.Mobile:
                    case ScreenSize.Tablet:
                        previewStyle.display = 'none';
                        break;
                }
            }
            content = (
                <Row style={{ flexWrap: 'nowrap', position: 'relative' }}>
                    <Column style={listStyle}>
                        <Row id={`artist__list-${this.props.blockIdentifier}`} className="cont__row--custom">
                            {listData.map((d, i) => (
                                <Column
                                    key={d.artistId}
                                    className="col--custom"
                                    size={columnSize}
                                    style={this.props.builder ? { pointerEvents: 'none' } : undefined}>
                                    <ListCell
                                        columnCount={columnCount}
                                        columnSpacing={this.props.blockConfig.list.columnSpacing}
                                        contentConfig={contentConfig}
                                        index={i}
                                        lineSpacing={lineSpacing}
                                        listData={listData}
                                        onMouseEnter={this.handleMouseEnter}
                                        {...this.props}
                                        data={d} />
                                </Column>
                            ))}
                        </Row>
                    </Column>
                    {
                        this.props.blockConfig.list.previewOnHover &&
                        <ArtistListCell.ArtistCellPreviewContainer
                            artistId={activeArtist && activeArtist.artistId}
                            blockConfig={this.props.blockConfig}
                            builder={this.props.builder}
                            className={previewClassName}
                            config={this.props.config}
                            contentConfig={previewContentConfig}
                            data={activeArtist}
                            id={`artist__preview-${this.props.blockIdentifier}`}
                            queryDataSub={this.props.queryDataSub}
                            queryLayout={this.props.queryLayout}
                            querySub={this.props.querySub}
                            style={previewStyle} />
                    }
                </Row>
            );
        } else {
            // Legacy
            content = (
                <Row>
                    <Column size="6">
                        <Row className="artist__list" id={`artist__list-${this.props.blockIdentifier}`}>
                            {listData.map((d) => (
                                <Column key={d.artistId} size="4">
                                    <ListCell onMouseEnter={this.handleMouseEnter} {...this.props} data={d} />
                                </Column>
                            ))}
                        </Row>
                    </Column>
                    <Column size="6">
                        {
                            this.state.activeArtist &&
                            <a href={this.state.activeArtist.url} id={`artist__preview-${this.props.blockIdentifier}`} className={`artist__preview${this.state.previewState ? ` artist__preview--${this.state.previewState}` : ''}`}>
                                <div className="artist__preview__img artist__preview__img--background" style={{ backgroundImage: `url(${this.state.activeArtist.imageUrl})` }} />
                                <div className="artist__preview__name">{this.state.activeArtist.name}</div>
                            </a>
                        }
                    </Column>
                </Row>
            )
        }
        return (
            <React.Fragment>
                <ContentContainer className="cont--kit__wrapper" style={containerStyle}>
                    <Spaced className="cont--kit__content" style={style}>
                        {content}
                    </Spaced>
                </ContentContainer>
                <Footer
                    active={this.props.active}
                    builder={this.props.builder}
                    hasMore={this.props.hasMore}
                    loading={this.props.loading}
                    onLoadMore={this.props.onLoadMore} />
            </React.Fragment>
        );
    }
}

function ListCell(props) {
    if (props.contentConfig) {
        return <ArtistListCell.ArtistCellContainer {...props} contentProps={{ onMouseEnter: () => props.onMouseEnter(props.data) }} type="list" />
    }
    const link = Url.getLink('', `artist/${props.data.artistId}`, { sub: props.querySub, layout: props.queryLayout, dataSub: props.queryDataSub }, props.builder);
    const images = ArtistHelper.images(props.data, props.blockConfig);
    let thumbnailUrl;
    if (props.imageSize) {
        thumbnailUrl = Image.url(images.thumbnail, props.imageSize, props.imageSize, 'c_fill', undefined, props.config && props.config.backgroundColor);
    }
    let linkStyle;
    if (props.builder) {
        linkStyle = { pointerEvents: 'none' };
    }
    return (
        <a href={link}
            className="artist__list__link"
            data-image={thumbnailUrl}
            data-name={props.data.name}
            data-url={link}
            style={linkStyle}
            value={props.data.artistId}
            onMouseEnter={() => props.onMouseEnter({ imageUrl: thumbnailUrl, name: props.data.name, url: link })}>
            <div className="artist__list__name notranslate">{props.data.name}</div>
        </a>
    );
}

// #endregion LIST

// #region SLIDESHOW

function _Slideshow(props) {
    let SlideComponent = Slide;
    let contentConfig;
    if (props.blockConfig.slideshow) {
        if (props.blockConfig.slideshow.cell && props.blockConfig.slideshow.cell.desktop && props.blockConfig.slideshow.cell.desktop.blocks && props.blockConfig.slideshow.cell.desktop.blocks.length > 0) {
            contentConfig = props.blockConfig.slideshow.cell;
        } else {
            contentConfig = Defaults.Block[Name.Block.Artist.List].SlideshowCell;
        }
        SlideComponent = ArtistListCell.ArtistCellContainer;
    }
    const listData = props.listData || [];
    return (
        <ContentContainer className="cont--kit__wrapper" style={props.containerStyle}>
            <Spaced style={props.style}>
                <Row className="slider--whitelabel">
                    <div id={props.sliderId} className="slider slider--full__width slider--artists" {...props.sliderProps}>
                        {
                            listData.map((d) => <SlideComponent  {...props} key={d.id} contentConfig={contentConfig} data={d} type="slideshow" />)
                        }
                    </div>
                    {props.arrows}
                </Row>
            </Spaced>
        </ContentContainer>
    );
}
const Slideshow = withSlideshowInitialization(
    withSlideshowConfiguration(
        _Slideshow,
        {
            arrowOffset: '11px',
            arrowStyle: { color: '#ADADAD', fontSize: '18px' },
            navStyle: { top: '46%' }
        }
    ),
    {
        autoplay: false,
        dots: false,
        items: 5,
        loop: true,
        nav: true,
        navText: ["", ""],
        margin: 40,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 3
            },
            1000: {
                items: 5
            }
        },
        smartSpeed: 1000
    }
);

function Slide(props) {
    const images = ArtistHelper.images(props.data, props.blockConfig);
    const link = Url.getLink('', `artist/${props.data.artistId}`, { sub: props.querySub, layout: props.queryLayout, dataSub: props.queryDataSub }, props.builder);
    let linkStyle;
    if (props.builder) {
        linkStyle = { pointerEvents: 'none' };
    }
    const size = 320;
    return (
        <div className="slider__slide artist__card--whitelabel">
            <a href={link} className="artist__card" style={linkStyle}>
                <img alt={props.data.name} className="artist__card__img" src={Image.url(images.thumbnail, size, size, 'c_fill')} />
                {
                    images.alternate &&
                    <img alt={props.data.name} className="artist__card__img artist__card__img--overlay" src={Image.url(images.alternate, size, size, 'c_fill')} />
                }
                <div className="artist__card__name notranslate">{props.data.name}</div>
            </a>
        </div>
    );
}

// #endregion SLIDESHOW

export default { Component: ArtistsListComponent };